var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",class:{'is-white': _vm.white, 'is-disabled': _vm.disabled, 'is-grow': _vm.grow, 'is-center': _vm.center, 'is-blue': _vm.blue, 'is-inner': _vm.inner}},[_vm._t("default"),(_vm.loading)?_c('app-icon',{staticClass:"loading",attrs:{"icon":"loading"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }